import { useIntl } from 'react-intl';
import type { ReactNode } from 'react';

/**
 * Wrapper hook that provides a useTranslations-like API compatible with next-intl.
 *
 * In next-intl: const t = useTranslations('auth');
 *               t('login.title') returns the translated string
 *               t.rich('login.title', { name: (chunks) => <b>{chunks}</b> }) for rich text
 *
 * In react-intl with this wrapper: const t = useTranslations('auth');
 *                                   t('login.title') returns the translated string
 *                                   t.rich('login.title', { name: (chunks) => <b>{chunks}</b> }) for rich text
 */
export function useTranslations<Namespace extends string = string>(namespace?: Namespace) {
  const intl = useIntl();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function t(key: string, values?: any): string {
    const fullKey = namespace ? `${namespace}.${key}` : key;
    return intl.formatMessage({ id: fullKey }, values);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t.rich = function rich(key: string, values?: any): ReactNode {
    const fullKey = namespace ? `${namespace}.${key}` : key;
    return intl.formatMessage({ id: fullKey }, values);
  };

  return t;
}
